<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import DefaultContentProductCard from './DefaultContent-ProductCard'
//import 'swiper/css/swiper.css'
/**
 * Dashboard Component
 */
export default {
  components: {
    Swiper,
    SwiperSlide,
    DefaultContentProductCard
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
    	hoverIndex: -1,
    	storageurl: 'https://'+this.$attrs.company.nickname+'.s3.eu-west-2.amazonaws.com',
    };
  },
  props: {
  	items: {
  		type: Array,
  		default: () => []
  	},
  	swiperOptions: {
				type: Object,
				default: () => {
          // Some Swiper option/callback...
        },
			},
	startSlide: {
		type: Number,
		default: () => 1
	},
	roundedBorders: {
		type: Boolean,
		default: () => true
	},
  },
  computed: {
      swiper() {
        return this.$refs.relatedProductsSwiper.$swiper
      }
    },
   mounted() {
    console.log('Current Swiper instance object', this.swiper);
      this.swiper.slideTo(this.startSlide, 1000, false);
  },
};
</script>

<template>
	<swiper ref="relatedProductsSwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in items">
            <DefaultContentProductCard :product="item.related_product_details"></DefaultContentProductCard>
        </swiper-slide>
    	<div class="swiper-pagination" slot="pagination"></div>
  	</swiper>
</template>